export const BOX_LAYOUT = "BOX_LAYOUT";
export const CHANGE_LAYOUT = "CHANGE_LAYOUT";
export const CHANGE_SUB_LAYOUT = "CHANGE_SUB_LAYOUT";
export const COLLAPSE_MENU = "COLLAPSE_MENU";
export const COLLAPSE_TOGGLE = "COLLAPSE_TOGGLE";
export const CONFIG_BLOCK = "CONFIG_BLOCK";
export const HEADER_BACK_COLOR = "HEADER_BACK_COLOR";
export const HEADER_FIXED_LAYOUT = "HEADER_FIXED_LAYOUT";
export const LAYOUT_TYPE = "LAYOUT_TYPE";
export const LAYOUT6_BACKGROUND = "LAYOUT6_BACKGROUND";
export const NAV_ACTIVE_LIST_COLOR = "NAV_ACTIVE_LIST_COLOR";
export const NAV_BRAND_COLOR = "NAV_BRAND_COLOR";
export const NAV_BACK_COLOR = "NAV_BACK_COLOR";
export const NAV_BACK_IMAGE = "NAV_BACK_IMAGE";
export const NAV_DROPDOWN_ICON = "NAV_DROPDOWN_ICON";
export const NAV_COLLAPSE_LEAVE = "NAV_COLLAPSE_LEAVE";
export const NAV_CONTENT_LEAVE = "NAV_CONTENT_LEAVE";
export const NAV_FIXED_LAYOUT = "NAV_FIXED_LAYOUT";
export const NAV_ICON_COLOR = "NAV_ICON_COLOR";
export const NAV_LIST_ICON = "NAV_LIST_ICON";
export const NAV_LIST_TITLE_COLOR = "NAV_LIST_TITLE_COLOR";
export const NAV_LIST_TITLE_HIDE = "NAV_LIST_TITLE_HIDE";
export const RESET = "RESET";
export const RTL_LAYOUT = "RTL_LAYOUT";

export const REGISTER = "REGISTER";
export const LOGIN = "LOGIN";
export const OTP_VALIDATION_SUCCESS = "OTP_VALIDATION_SUCCESS";
export const OTP_VALIDATION_FAIL = "OTP_VALIDATION_FAIL";
export const LOGOUT = "LOGOUT";
export const ACCOUNT_INITIALISE = "ACCOUNT_INITIALISE";
export const FIREBASE_STATE_CHANGED = "FIREBASE_STATE_CHANGED";

//user constants
export const ALL_USERS_REQUEST = "ALL_USERS_REQUEST";
export const ALL_USERS_SUCCESS = "ALL_USERS_SUCCESS";
export const ALL_USERS_FAIL = "ALL_USERS_FAIL";

export const LOGGED_USERS_REQUEST = "LOGGED_USERS_REQUEST";
export const LOGGED_USERS_SUCCESS = "LOGGED_USERS_SUCCESS";
export const LOGGED_USERS_FAIL = "LOGGED_USERS_FAIL";

export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";

// Dashboard KPI constants

// TOP DSE KPI's
export const TOP_DSE_REQUEST = "TOP_DSE_REQUEST";
export const TOP_DSE_SUCCESS = "TOP_DSE_SUCCESS";
export const TOP_DSE_FAIL = "TOP_DSE_FAIL";

// LOGIN STATUS KPI's
export const GET_LOGIN_STATUS_REQUEST = "GET_LOGIN_STATUS_REQUEST";
export const GET_LOGIN_STATUS_SUCCESS = "GET_LOGIN_STATUS_SUCCESS";
export const GET_LOGIN_STATUS_FAIL = "GET_LOGIN_STATUS_FAIL";

// PARTSKART LOGIN STATUS KPI's
export const GET_PARTSKART_LOGIN_REQUEST = "GET_PARTSKART_LOGIN_REQUEST";
export const GET_PARTSKART_LOGIN_SUCCESS = "GET_PARTSKART_LOGIN_SUCCESS";
export const GET_PARTSKART_LOGIN_FAIL = "GET_PARTSKART_LOGIN_FAIL";

export const GET_LOGIN_ADDITIONAL_DATA_REQUEST =
  "GET_LOGIN_ADDITIONALDATA_REQUEST";
export const GET_LOGIN_ADDITIONAL_DATA_SUCCESS =
  "GET_LOGIN_ADDITIONALDATA_SUCCESS";
export const GET_LOGIN_ADDITIONAL_DATA_FAIL = "GET_LOGIN_ADDITIONALDATA_FAIL";

// APP USAGE STATUS KPI's
export const GET_APP_USAGE_REQUEST = "GET_APP_USAGE_REQUEST";
export const GET_APP_USAGE_SUCCESS = "GET_APP_USAGE_SUCCESS";
export const GET_APP_USAGE_FAIL = "GET_APP_USAGE_FAIL";

// PARTS ANALYSIS KPI's
export const PARTS_ANALYSIS_REQUEST = "PARTS_ANALYSIS_REQUEST";
export const PARTS_ANALYSIS_SUCCESS = "PARTS_ANALYSIS_SUCCESS";
export const PARTS_ANALYSIS_FAIL = "PARTS_ANALYSIS_FAIL";
export const PARTS_ANALYSIS_ADDITIONAL_REQUEST =
  "PARTS_ANALYSIS_ADDITIONAL_REQUEST";
export const PARTS_ANALYSIS_ADDITIONAL_SUCCESS =
  "PARTS_ANALYSIS_ADDITIONAL_SUCCESS";
export const PARTS_ANALYSIS_ADDITIONAL_FAIL = "PARTS_ANALYSIS_ADDITIONAL_FAIL";

// CUSTOMER REPORT KPI's
export const CUSTOMER_REPORT_REQUEST = "CUSTOMER_REPORT_REQUEST";
export const CUSTOMER_REPORT_SUCCESS = "CUSTOMER_REPORT_SUCCESS";
export const CUSTOMER_REPORT_FAIL = "CUSTOMER_REPORT_FAIL";

export const CUSTOMER_ADDITIONAL_DATA_REQUEST =
  "CUSTOMER_ADDITIONAL_DATA_REQUEST";
export const CUSTOMER_ADDITIONAL_DATA_SUCCESS =
  "CUSTOMER_ADDITIONAL_DATA_SUCCESS";
export const CUSTOMER_ADDITIONAL_DATA_FAIL = "CUSTOMER_ADDITIONAL_DATA_FAIL";

// PARTIES VISITED TOP DSE KPI's
export const PARTIES_VISITED_TOPDSE_REQUEST = "PARTIES_VISITED_TOPDSE_REQUEST";
export const PARTIES_VISITED_TOPDSE_SUCCESS = "PARTIES_VISITED_TOPDSE_SUCCESS";
export const PARTIES_VISITED_TOPDSE_FAIL = "PARTIES_VISITED_TOPDSE_FAIL";

//Assets constants
export const ALL_PARTCART_LOGGED_USERS_REQUEST =
  "ALL_PARTCART_LOGGED_USERS_REQUEST";
export const ALL_PARTCART_LOGGED_USERS_SUCCESS =
  "ALL_PARTCART_LOGGED_USERS_SUCCESS";
export const ALL_PARTCART_LOGGED_USERS_FAIL = "ALL_PARTCART_LOGGED_USERS_FAIL";
export const ASSETS_LIST_REQUEST = "ASSETS_LIST_REQUEST";
export const ASSETS_LIST_SUCCESS = "ASSETS_LIST_SUCCESS";
export const ASSETS_LIST_FAIL = "ASSETS_LIST_FAIL";
export const ASSETS_LIST_CLEAR = "ASSETS_LIST_CLEAR";

export const ASSET_ADD_REQUEST = "ASSET_ADD_REQUEST";
export const ASSET_ADD_SUCCESS = "ASSET_ADD_SUCCESS";
export const ASSET_ADD_FAIL = "ASSET_ADD_FAIL";

export const ALL_ASSET_REQUEST = "ALL_ASSET_REQUEST";
export const ALL_ASSET_SUCCESS = "ALL_ASSET_SUCCESS";
export const ALL_ASSET_FAIL = "ALL_ASSET_FAIL";

//campaign constants
export const ALL_CAMPAIGN_LIST_REQUEST = "ALL_CAMPAIGN_LIST_REQUEST";
export const ALL_CAMPAIGN_LIST_SUCCESS = "ALL_CAMPAIGN_LIST_SUCCESS";
export const ALL_CAMPAIGN_LIST_FAIL = "ALL_CAMPAIGN_LIST_FAIL";
export const CAMPAIGN_DETAILS_REQUEST = "CAMPAIGN_DETAILS_REQUEST";
export const CAMPAIGN_DETAIL_SUCCESS = "CAMPAIGN_DETAIL_SUCCESS";
export const CAMPAIGN_DETAILS_FAIL = "CAMPAIGN_DETAILS_FAIL";
export const CAMPAIGN_NAME = "CAMPAIGN_NAME";
export const ASSET_MANAGER_NAME = "ASSET_MANAGER_NAME";
export const ASSET_NAME = "ASSET_NAME";
export const TITLE = "TITLE";
export const MEDIA_LINK = "MEDIA_LINK";
export const NOTIFICATION_BODY = "NOTIFICATION_BODY";
export const SEGMENT = "SEGMENT";
export const SEGMENT_TYPE = "SEGMENT_TYPE";
export const DATE = "DATE";
export const ASSET_LIST = "ASSET_LIST";
export const TITLE_ERROR = "TITLE_ERROR";
export const TEXT_MESSAGE_ERROR = "TEXT_MESSAGE_ERROR";
export const DATE_ERROR = "DATE_ERROR";
export const ASSET_MANAGER_ERROR = "ASSET_MANAGER_ERROR";
export const ASSET_ERROR = "ASSET_ERROR";
export const CAMPAIGN_NAME_ERROR = "CAMPAIGN_NAME_ERROR";
export const SEGMENT_TYPE_ERROR = "SEGMENT_TYPE_ERROR";
export const FILE_SIZE_ERROR = "FILE_SIZE_ERROR";
export const SEGMENT_ERROR = "SEGMENT_ERROR";
export const NOTIFICATION_MESSAGE_ERROR = "NOTIFICATION_MESSAGE_ERROR";
export const IS_FILE_SIZE_ERROR = "IS_FILE_SIZE_ERROR";

export const IS_DATE_ERROR = "IS_DATE_ERROR";
export const IS_NOTIFICATION_MESSAGE_ERROR = "IS_NOTIFICATION_MESSAGE_ERROR";
export const IS_SEGMENT_IMAGE_SET = "IS_SEGMENT_IMAGE_SET";
export const IS_SEGMENT_ERROR = "IS_SEGMENT_ERROR";
export const IS_SEGMENT_TYPE_ERROR = "IS_SEGMENT_TYPE_ERROR";
export const IS_CAMPAIGN_NAME_ERROR = "IS_CAMPAIGN_NAME_ERROR";
export const IS_ASSET_ERROR = "IS_ASSET_ERROR";
export const IS_SEGMENT_SELECTED = "IS_SEGMENT_SELECTED";
export const IS_ASSET_MANAGER_ERROR = "IS_ASSET_MANAGER_ERROR";
export const IS_TEXT_MESSAGE_ERROR = "IS_TEXT_MESSAGE_ERROR";
export const IS_TITLE_ERROR = "IS_TITLE_ERROR";
export const IS_IMAGE_SET = "IS_IMAGE_SET";
export const IS_DISPLAY = "IS_DISPLAY";
export const IS_CHECKED = "IS_CHECKED";
export const IS_BUTTON_DISABLE = "IS_BUTTON_DISABLE";

export const IS_NOTIFICATION_TYPE_ERROR = "IS_NOTIFICATION_TYPE_ERROR";
export const NOTIFICATION_TYPE = "NOTIFICATION_TYPE";
export const NOTIFICATION_TYPE_ERROR = "NOTIFICATION_TYPE_ERROR";

export const NOTIFICATION_DETAIL_REQUEST = "NOTIFICATION_DETAIL_REQUEST";
export const NOTIFICATION_DETAIL_SUCCESS = "NOTIFICATION_DETAIL_SUCCESS";
export const NOTIFICATION_DETAIL_FAIL = "NOTIFICATION_DETAIL_FAIL";

export const LOCATION_UPDATE_REQUEST = "LOCATION_UPDATE_REQUEST";
export const LOCATION_UPDATE_SUCCESS = "LOCATION_UPDATE_SUCCESS";
export const LOCATION_UPDATE_FAIL = "LOCATION_UPDATE_FAIL";

export const VISIT_TRACKER_REQUEST = "VISIT_TRACKER_REQUEST";
export const VISIT_TRACKER_SUCCESS = "VISIT_TRACKER_SUCCESS";
export const VISIT_TRACKER_FAIL = "VISIT_TRACKER_FAIL";

//Order collection
export const GET_ORDER_COLLECTION_REQUEST = "GET_ORDER_COLLECTION_REQUEST";
export const GET_ORDER_COLLECTION_SUCCESS = "GET_ORDER_COLLECTION_SUCCESS";
export const GET_ORDER_COLLECTION_FAIL = "GET_ORDER_COLLECTION_FAIL";

// Partskart Order Collection
export const GET_PARTSKART_ORDER_REQUEST = "GET_PARTSKART_ORDER_REQUEST";
export const GET_PARTSKART_ORDER_SUCCESS = "GET_PARTSKART_ORDER_SUCCESS";
export const GET_PARTSKART_ORDER_FAIL = "GET_PARTSKART_ORDER_FAIL";

// kpi constant
export const CustomerVisitReport = "Customer visit report";
export const LocationUpdateStatus = "Location Update Status";
export const LoginActivity = "Login activity";
export const LeadInformation = "Lead Information";
export const AverageNumberOfPartsPerLead = "Average number of parts per lead";
export const TopFiveDSEs = "Top 5 DSEs";
export const OrderValue = "Order value";
export const AdvanceVisitTracker = "VisitTracker";
export const OrderCollectionReport = "OrderCollectionReport";
export const IwResearch = "IwResearch";
export const NoStock = "NoStock";
export const PartKartLoginActivity = "Partskart Login activity";
export const PartskartOrderCollection = "Partskart Order Collection";

//IW Research collection
export const IW_RESEARCH_REQUEST = "IW_RESEARCH_REQUEST";
export const IW_RESEARCH_SUCCESS = "IW_RESEARCH_SUCCESS";
export const IW_RESEARCH_FAIL = "IW_RESEARCH_FAIL";

//No Stock
export const NO_STOCK_REQUEST = "NO_STOCK_REQUEST";
export const NO_STOCK_SUCCESS = "NO_STOCK_SUCCESS";
export const NO_STOCK_FAIL = "NO_STOCK_FAIL";
